import { Tooltip, Tag, Space, Button, Flex } from "antd";
import { CopyTextToClipboard } from "../../../helpers/copy";
import { CopyTwoTone, EyeOutlined } from "@ant-design/icons";
import moment from "moment";
import { FormatTimeAgo } from "../../../helpers/formatTimeAgo";
import {
  FormatDataSettleSlip,
} from "../../../helpers/formatDataJson";

import { tagsBageStatus } from "../../../helpers/tagsBage";
import { getIcon } from "../../../helpers/getIcon";

export const ColumnsDeposit = (t, handleShowDetails, tableParams) => [

  // ID
  {
    title: t("ID"),
    key: "id",
    dataIndex: "id",
    render: (id, record, index) => (
      <>
        {id
          ? `#${id}`
          : (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize +
          index +
          1}
      </>
    ),
    sorter: false,
  },

  // REF
  {
    title: t("REF UUID"),
    dataIndex: "refUuid",
    key: "refUuid",
    render: (ref) => (
      <div className="d-flex align-items-center">
        <Tooltip
          key={`tooltip-${ref}`}
          placement="topLeft"
          color="#3eacff"
          title={ref}
        >
          <span
            className="text-truncate"
            style={{
              textWrap: "nowrap",
              maxWidth: 100,
              width: "100%",
              color: "#3eacff",
              display: "inline-block",
            }}
          >
            {ref}{" "}
          </span>
        </Tooltip>
        <span className="">
          <CopyTwoTone
            style={{ cursor: "copy" }}
            onClick={() => CopyTextToClipboard(ref)}
          />
        </span>
      </div>
    ),
  },

  // createdAt
  {
    title: t("createdAt"),
    filterSearch: true,
    dataIndex: "created_at",
    key: "created_at",
    render: (date) => (
      <span style={{ maxWidth: "60px" }} className="text-truncate">
        <Tooltip>
          {moment(date).format("YYYY-MM-DD")},{" "}
          <span style={{ fontWeight: "500" }}>
            {moment(date).format("HH:mm:ss")}
          </span>
          <br />
          <span style={{ fontWeight: "500" }}>( {FormatTimeAgo(date)} )</span>
        </Tooltip>
      </span>
    ),
  },


  // status
  {
    title: t("status"),
    dataIndex: "status",
    key: "status",
    render: (status) => (
      <Tag
        style={{ textTransform: "uppercase", fontWeight: "700" }}
        color={tagsBageStatus(status)}
        key={status}
        icon={getIcon(status)}
      >
        {t(status)}
      </Tag>
    ),
  },

  // amount
  {
    title: (
      <span className="text-truncate">
        {t("deposit amt")} <br /> {t("tarnsfer amt")}
      </span>
    ),
    render: (item) => (
      <>
        <span style={{ textTransform: "uppercase" }}>
          <b className="text-truncate">
            THB {Intl.NumberFormat().format(parseFloat(item.amount).toFixed(2))}
          </b>{" "}
          <br />{" "}
          <span className="text-truncate">
            THB{" "}
            {Intl.NumberFormat().format(
              parseFloat(item.transferAmount).toFixed(2),
            )}
          </span>
        </span>
      </>
    ),
  },

  // note
  {
    title: <span className="text-truncate">{t("note")}</span>,
    dataIndex: "note",
    key: "note",
    render: (note) => (
      <span>
        {note ? (
          <div title={note} className="text-truncate" style={{ maxWidth: 100 }}>
            {note}
          </div>
        ) : (
          <em style={{ color: "#888" }}>
            <small>No data</small>
          </em>
        )}
      </span>
    ),
  },

  // action
  {
    title: <span className="text-truncate">{t("action")}</span>,
    key: "action",
    fixed: "right",
    width: 50,
    render: (_, record) => (
      <>
        <Space size="middle">
          <div title={t("Details")}>
            <Button
              shape="circle"
              size="middle"
              onClick={() => handleShowDetails(record)} // Ensure handleShow is passed
              icon={<EyeOutlined />}
            />
          </div>
        </Space>
      </>
    ),
  },
];

export const ColumnsWithdraw = (t, handleShowDetails, tableParams) => [
  // ID
  {
    title: t("ID"),
    key: "id",
    dataIndex: "id",
    render: (id, record, index) => (
      <>
        {id
          ? `#${id}`
          : (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize +
          index +
          1}
      </>
    ),

    sorter: false,
  },

  // REF UUID
  {
    title: t("REF UUID"),
    filterSearch: true,
    dataIndex: "refUuid",
    key: "refUuid",
    render: (ref) => (
      <div className="d-flex align-items-center">
        <Tooltip
          key={`ref-${ref}`}
          placement="topLeft"
          color="#3eacff"
          title={ref}
        >
          <span
            className="text-truncate"
            style={{
              textWrap: "nowrap",
              maxWidth: 100,
              color: "#3eacff",
              display: "inline-block",
            }}
          >
            {ref}
          </span>
        </Tooltip>
        <span className="ms-2" style={{ marginLeft: "5px" }}>
          <CopyTwoTone
            style={{ cursor: "copy" }}
            onClick={() => CopyTextToClipboard(ref)}
          />{" "}
        </span>
      </div>
    ),
  },

  // createdAt & updatedAt
  {
    title: (
      <>
        {t("createdAt")} <br /> {t("updatedAt")}
      </>
    ),
    filterSearch: true,
    dataIndex: "created_at",
    key: "created_at",
    render: (date, record) => {
      let formatShot = "YYYY-MM-DD";
      let formatTime = "HH:mm:ss";
      let settleSlip = record?.settleSlip;
      let status = record?.status === "SUCCESS";
      let created_at = moment(date).format(formatShot);
      let createdTime = moment(date).format(formatTime);
      const isSettleSlip = settleSlip ? FormatDataSettleSlip(settleSlip) : null;
      let updatedDateTime = isSettleSlip?.updatedDateTime || null;
      const updatedDate = updatedDateTime
        ? moment(updatedDateTime).format(formatShot)
        : null;
      const updatedTime = updatedDateTime
        ? moment(updatedDateTime).format(formatTime)
        : null;
      return (
        <span style={{ maxWidth: "60px" }} className="text-truncate">
          <Tooltip>
            {created_at}{" "}
            <span style={{ fontWeight: "500" }}>{createdTime}</span>
            <br />
            {status ? (
              <>
                {updatedDate}{" "}
                <span style={{ fontWeight: "500" }}>{updatedTime}</span>
              </>
            ) : (
              <>
                <span style={{ fontWeight: "500" }}>
                  ( {FormatTimeAgo(date)} )
                </span>
              </>
            )}
          </Tooltip>
        </span>
      );
    },
  },


  // status
  {
    title: t("status"),
    dataIndex: "status",
    key: "status",
    render: (status, record) => {
      return (
        <span
          className="text-truncate"
          style={{ display: "inline-flex", alignItems: "center" }}
        >
          <Tag
            style={{ textTransform: "capitalize", fontWeight: "500" }}
            color={tagsBageStatus(status)}
            icon={getIcon(status)}
          >
            {status}{" "}
          </Tag>
        </span>
      );
    },
  },

  // amount
  {
    title: (
      <span className="text-truncate">
        {t("withdraw amt")} <br /> {t("tarnsfer amt")}
      </span>
    ),
    key: "amount",
    dataIndex: "amount",
    filterSearch: true,
    render: (amount, record) => {
      return (
        <>
          <span style={{ textTransform: "uppercase" }}>
            <b className="text-truncate">
              THB {Intl.NumberFormat().format(parseFloat(amount).toFixed(2))}
            </b>{" "}
            <br />{" "}
            <span className="text-truncate">
              THB{" "}
              {Intl.NumberFormat().format(
                parseFloat(record?.transferAmount || amount).toFixed(2),
              )}{" "}
            </span>
          </span>
        </>
      );
    },
  },

  // remark
  {
    title: <span className="text-truncate">{t("remark")}</span>,
    key: "note",
    dataIndex: "note",
    filterSearch: true,
    width: 150,
    render: (note, record) => {
      return (
        <div
          className="text-truncate"
          style={{ fontSize: "13px", maxWidth: 150 }}
        >
          {note}
        </div>
      );
    },
  },

  // action
  {
    title: <span className="text-truncate">{t("action")}</span>,
    fixed: "right",
    width: 50,
    render: (_, record) => {
      return (
        <Flex gap={0} vertical>
          <div className="">
            <Flex wrap gap={4}>
              <Button
                shape="circle"
                type="default"
                size="middle"
                onClick={() => handleShowDetails(record)}
                icon={<EyeOutlined />}
                title={t("Details")}
              />
            </Flex>
          </div>
        </Flex>
      );
    },
  },
];
